import React, { ReactNode, Ref, forwardRef } from 'react';
import ExportLogo from '@/images/logos/hudlStatsbomb.svg';
import { ExportComparisonHeader, ExportStandardHeader } from './ExportTemplateHeaders';

/**
 * ExportTemplate
 * A component that displays a visualisation in a template as a preview before exporting
 */
interface ExportTemplateProps {
  children: ReactNode;
  title: string;
  templateName?: string;
  secondaryTitlePrefix?: string;
  firstSubtitle?: string;
  secondSubtitle?: string;
  thirdSubtitle?: string;
  info1?: string;
  info2?: string;
  comparisonTitle?: string;
  comparisonCountryCode?: string | null;
  primaryTeamInfo?: string;
  comparisonTeamInfo?: string;
  comparisonInfo1?: string;
  comparisonInfo2?: string;
  width: string;
  withLogo?: boolean;
}

const ExportTemplate = forwardRef(
  (
    {
      children,
      title,
      templateName = '',
      secondaryTitlePrefix = '',
      firstSubtitle = '',
      secondSubtitle = '',
      thirdSubtitle = '',
      info1 = '',
      info2 = '',
      comparisonTitle = '',
      comparisonCountryCode,
      primaryTeamInfo = '',
      comparisonTeamInfo = '',
      comparisonInfo1 = '',
      comparisonInfo2 = '',
      width,
      withLogo,
    }: ExportTemplateProps,
    exportRef: Ref<HTMLDivElement>,
  ) => (
    <div className="flex flex-col gap-4 bg-canvas-tertiary-main p-4" style={{ width }} ref={exportRef}>
      <header className="flex flex-col w-full">
        {comparisonTitle ? (
          <ExportComparisonHeader
            title={title}
            comparisonTitle={comparisonTitle}
            comparisonCountryCode={comparisonCountryCode}
            primaryTeamInfo={primaryTeamInfo}
            comparisonTeamInfo={comparisonTeamInfo}
            info1={info1}
            info2={info2}
            comparisonInfo1={comparisonInfo1}
            comparisonInfo2={comparisonInfo2}
            templateName={templateName}
            secondaryTitlePrefix={secondaryTitlePrefix}
          />
        ) : (
          <ExportStandardHeader
            title={title}
            templateName={templateName}
            secondaryTitlePrefix={secondaryTitlePrefix}
            firstSubtitle={firstSubtitle}
            secondSubtitle={secondSubtitle}
            thirdSubtitle={thirdSubtitle}
          />
        )}
      </header>
      <div className="flex gap-4 pointer-events-none">{children}</div>
      {withLogo && (
        <div className="w-[140px] ml-auto">
          <ExportLogo data-testid="export-logo" />
        </div>
      )}
    </div>
  ),
);

export default ExportTemplate;
